import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { } from "../../store/actions";
import SimpleBar from "simplebar-react";
import { withNamespaces } from 'react-i18next';
import SidebarContent from "./SidebarContent";

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {

        return (
            <React.Fragment>
                <div className="vertical-menu">
                    <div data-simplebar className="h-100">
                        {this.props.type !== "condensed" ? (
                            <SimpleBar style={{ maxHeight: "100%" }}>
                                <SidebarContent />
                            </SimpleBar>
                        ) : <SidebarContent />}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return {
        layout: state.Layout,
        permissions : state.Permission.permissions,
        high_division: state.Member.high_division,
		is_patronager: state.Member.is_patronager,
        is_diaspora_coordinator: state.Member.is_diaspora_coordinator,
        is_ftv_coordinator: state.Member.is_ftv_coordinator,
    };
};

export default connect(mapStatetoProps, {})(withRouter(withNamespaces()(Sidebar)));
